export default "__VITE_ASSET__69c47445__"